import * as React from "react";
const useFirstRender = (callback) => {
  const isFirstRender = React.useRef(true);
  if (isFirstRender.current) {
    isFirstRender.current = false;
    callback();
  }
};
export {
  useFirstRender
};
//# sourceMappingURL=useFirstRender.es.js.map
